import { combineReducers } from 'redux';
import themeUsersReducer from './themeUsers/reducers';
import authReducer from './authentication/reducers';
import ChangeLayoutMode from './themeLayout/reducers';
import { userReducer, userGroupReducer } from './users/reducers';
import { headerSearchReducer } from './headerSearch/reducers';
import Profile from './profile/reducers';
import dataTable from './data-filter/reducers';

const rootReducers = combineReducers({
  themeUsers: themeUsersReducer,
  headerSearchData: headerSearchReducer,
  users: userReducer,
  userGroup: userGroupReducer,
  auth: authReducer,
  ChangeLayoutMode,
  Profile,
  dataTable,
});

export default rootReducers;
